export default __webpack_public_path__ + "static/media/livelinklist-home.93b649c3.png";